module.exports = __webpack_public_path__ + "img/audio.c70ccded.png";